import { render, staticRenderFns } from "./user-allocate.vue?vue&type=template&id=5789a29c&scoped=true"
import script from "./user-allocate.vue?vue&type=script&lang=ts"
export * from "./user-allocate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5789a29c",
  null
  
)

export default component.exports